// TanStack hook for the cluster-manager's running version.
//
// The endpoint is public (no session required) so this works on the
// login screen too. Cached for an hour because the value can only
// change on a service restart, which the user will already see as
// page load failures.

import { useQuery } from "@tanstack/react-query";
import { api, unwrap } from "@/lib/api";

export interface SystemVersionPayload {
	version: string;
	releasedAt: string | null;
	source: "version-file" | "package-json" | "unknown";
	startedAt: string;
}

interface SystemVersionEnvelope {
	success: boolean;
	system: SystemVersionPayload;
}

export function useSystemVersion() {
	return useQuery({
		queryKey: ["system", "version"],
		queryFn: async () => {
			const env = (await unwrap(
				api.api.system.version.get(),
			)) as SystemVersionEnvelope;
			return env.system;
		},
		staleTime: 60 * 60_000,
		gcTime: 24 * 60 * 60_000,
		retry: 1,
	});
}
